// import { Spin } from 'antd';

// const CustomLoader: React.FC = () => {
//     return (
//         <div className="fixed inset-0 flex items-center justify-center z-50 bg-opacity-50 backdrop-blur-xs">
//             <Spin size="large" />
//         </div>
//     );
// };

// export default CustomLoader;

import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const antIcon = <LoadingOutlined spin />;
const CustomLoader = (props:any) => (
  <div className='loaderWrapper'>
    <Spin 
      // tip={Array(2).fill('\xa0').join('') + `${props?.tip || ''}`} 
      indicator={antIcon} 
      size="large" 
      className='spinLoader' />
  </div>
);
export default CustomLoader;